"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldTitle = OfferAssetGalleryFieldTitle;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const elements_1 = require("@src/components/elements");
const react_intl_1 = require("react-intl");
function OfferAssetGalleryFieldTitle({ fieldName }) {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: [fieldName, types_1.EOfferGalleryKey.title], label: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.title.label' }), rules: [
            {
                required: true,
                message: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.title.required' }),
            },
            {
                max: 100,
                message: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.title.too_long' }),
            },
        ], children: (0, jsx_runtime_1.jsx)(elements_1.Input, { placeholder: intl.formatMessage({ id: 'admin.offer.assets.gallery_form.title.placeholder' }), maxLength: 100 }) }));
}
